// https://billpocket.atlassian.net/wiki/spaces/BPD/pages/1189543949/Tipos+de+Links
export default {
  UNIQUE_WITHOUT_EXPIRES: 1,
  WITH_AMOUNT_AND_TO_BE_USED_ONCE: 2,
  WITH_AMOUNT_AND_EXPIRY: 3,
  WITH_OPEN_AMOUNT_AND_WITHOUT_EXPIRY: 4,
  WITH_OPEN_AMOUNT_AND_TO_BE_USED_ONCE: 5,
  WITH_OPEN_AMOUNT_AND_EXPIRY: 6,
  WITH_RELATED_PURCHASE_FOR_BP_DEVICES: 7,
};
